// Campos obrigatórios da parcela da Previsão (D-0124, Rafael 28/10).
//
// Estavam enviando parcela ao Financeiro sem forma de pagamento. Regra: "somente observação
// NÃO é OBRIGATÓRIO, os demais são." Parcela antiga incompleta não é corrigida em lote: trava
// ao editar e ao enviar, até o operador completar no modal.
//
// Espelho de DadosPagamentoService::faltantesPrevisao (a API é a camada que decide).

// Mesmas opções do select "Forma de Pagamento" do modal Nova/Editar Parcela.
export const FORMAS_PREVISAO = ['pix', 'cartao_credito', 'cartao_fisico', 'cartao_debito', 'boleto', 'fatura', 'remessa', 'link', 'apolice'];

const dataValida = (data) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(data || ''));
    if (!m) return false;
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return d.getFullYear() === Number(m[1]) && d.getMonth() === Number(m[2]) - 1 && d.getDate() === Number(m[3]);
};

/** Campos que faltam: { valor, data_pagamento, forma } → ['valor', 'data_pagamento', 'forma']. */
export const camposFaltantesPrevisao = (parcela) => {
    const p = parcela || {};
    const faltam = [];
    if (!(Number(p.valor) > 0)) faltam.push('valor');
    if (!dataValida(p.data_pagamento)) faltam.push('data_pagamento');
    if (!FORMAS_PREVISAO.includes(p.forma)) faltam.push('forma');
    return faltam;
};

const ROTULOS = { valor: 'Valor', data_pagamento: 'Data de Pagamento', forma: 'Forma de Pagamento' };

/** Aviso do modal; null quando a parcela está completa. */
export const avisoFaltantesPrevisao = (faltam) => (faltam && faltam.length
    ? 'Preencha os campos obrigatórios: ' + faltam.map(c => ROTULOS[c]).join(', ') + '. Só a Observação é opcional.'
    : null);
